/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Popup} from '../../../JSX/Popup/Popup';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {$AutoplayStartButton} from './AutoplayStartButton';
import {$HorizontalSeparator} from '../../../JSX/HorizontalSeparator';
import {getPopupResponsiveConfig} from './etc';
import {$AutoplayRoundsSelector} from './AutoplayRoundsSelector';
import {$AutoplayOptionsSelector} from './AutoplayOptionsSelector';

export type $AutoplaySettingsRubyProps = CanBeSignals<{
    showOptionsPopup: boolean;
    defaultSpins: number;
    autoplayValues: number[];
    untilBonus: boolean;
    singleWin: number | null;
    winLimit: number | null;
    lossLimit: number | null;
    onUntilBonus: (value: boolean) => void;
    onStartAutoplay: (value: number) => void;
    onUpdateValue: (value: number) => void;
    onLossLimit: (value: number | null) => void;
    onWinLimit: (value: number | null) => void;
    onSingleWin: (value: number | null) => void;
    onCancel: () => void;
}>;

export const $AutoplayOptionsPopup: FC<$AutoplaySettingsRubyProps> = (props) => {
    const {
        showOptionsPopup,
        defaultSpins,
        autoplayValues,
        untilBonus,
        singleWin,
        winLimit,
        lossLimit,
        onUntilBonus,
        onStartAutoplay,
        onUpdateValue,
        onWinLimit,
        onLossLimit,
        onSingleWin,
        onCancel,
    } = props;

    const responsive = getPopupResponsiveConfig();

    const roundsCount = Store.signal(getProp(defaultSpins));

    return <$Popup
        localeID='autoplayOptions'
        show={showOptionsPopup}
        onCancel={onCancel}
        responsive={responsive.popupBgConfig}
    >
        <$AutoplayOptionsSelector
            responsive={responsive.optionsSelector}
            untilBonus={{value: untilBonus, action: onUntilBonus}}
            singleWin={{value: singleWin, action: onSingleWin}}
            winLimit={{value: winLimit, action: onWinLimit}}
            lossLimit={{value: lossLimit, action: onLossLimit}}
        />

        <$AutoplayRoundsSelector
            responsive={responsive.roundsSelector}
            roundsCount={roundsCount}
            options={getProp(autoplayValues)}
            action={(index: number) => getProp(onUpdateValue)((roundsCount.value = index))}
        />

        <$HorizontalSeparator
            lineWidth={Store.computed(() => slotStore.stage_isPortrait.value ? 820 : 1324)}
            lineAlpha={0.2}
            responsive={responsive.separator1Config}
        />

        <$HorizontalSeparator
            lineWidth={Store.computed(() => slotStore.stage_isPortrait.value ? 820 : 1324)}
            lineAlpha={0.2}
            responsive={responsive.separator2Config}
        />

        <$AutoplayStartButton
            responsive={responsive.autoplayBtnConfig}
            action={() => getProp(onStartAutoplay)(roundsCount.value)}
        />
    </$Popup>;
};